import { readonly, ref, useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
import { saveBillingAddressCommand } from "./commands/saveBillingAddressCommand";
import useShippingProvider from "../useShippingProvider";
import { useCart } from "@wemade-vsf/customer";
function useBilling() {
  const context = useContext();
  const { load: loadShippingAddress, save: saveShippingAddress } = useShippingProvider();
  const { cart, load: loadCart } = useCart();
  const loading = ref(false);
  const error = ref({
    load: null,
    save: null
  });
  const load = async ({ customQuery = null, customHeaders = {} } = {}) => {
    var _a, _b, _c;
    Logger.debug("useBilling.load");
    let billingInfo = null;
    try {
      loading.value = true;
      if (!((_a = cart == null ? void 0 : cart.value) == null ? void 0 : _a.billing_address)) {
        await loadCart({ customQuery, customHeaders });
      }
      billingInfo = (_c = (_b = cart == null ? void 0 : cart.value) == null ? void 0 : _b.billing_address) != null ? _c : null;
      error.value.load = null;
    } catch (err) {
      error.value.load = err;
      Logger.error("useBilling/load", err);
    } finally {
      loading.value = false;
    }
    return billingInfo;
  };
  const save = async ({ billingDetails, customQuery = null, customHeaders = {} }) => {
    Logger.debug("useBilling.save");
    let billingInfo = null;
    try {
      loading.value = true;
      billingInfo = await saveBillingAddressCommand.execute(context, cart.value.id, billingDetails, customQuery, customHeaders);
      const shippingMethod = await loadShippingAddress();
      Logger.debug("[Magento]: Defining the shipping method as:", JSON.stringify(shippingMethod, null, 2));
      if (shippingMethod == null ? void 0 : shippingMethod.carrier_code) {
        await saveShippingAddress({
          shippingMethod: {
            carrier_code: shippingMethod.carrier_code,
            method_code: shippingMethod.method_code
          }
        });
      }
      error.value.save = null;
    } catch (err) {
      error.value.save = err;
      Logger.error("useBilling/save", err);
    } finally {
      loading.value = false;
    }
    return billingInfo;
  };
  return {
    load,
    save,
    error: readonly(error),
    loading: readonly(loading)
  };
}
export * from "./useBilling";
var useBilling_default = useBilling;
export {
  useBilling_default as default,
  useBilling
};
